export default "__VITE_ASSET__BVJ94ME$__"